import React from 'react';
import { NewsItem } from '../store/slices/postsSlice';
import './NewsCard.css';

interface NewsCardProps {
  news: NewsItem;
}

const formatDate = (dateString: string) => {
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const hours = Math.floor(diff / (1000 * 60 * 60));

    if (hours < 1) return 'Just now';
    if (hours < 24) return `${hours}h ago`;
    if (hours < 168) return `${Math.floor(hours / 24)}d ago`;
    return date.toLocaleDateString();
  } catch {
    return '';
  }
};

const formatLocation = (news: NewsItem) => {
  const parts = [news.city, news.state_province, news.country].filter(Boolean);
  return parts.join(', ');
};

const NewsCard: React.FC<NewsCardProps> = ({ news }) => {
  const location = formatLocation(news);
  return (
    <a
      className="news-card"
      href={news.link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="news-content">
        <div className="news-header">
          <span className="news-badge">NEWS</span>
          <span className="news-source">{news.source}</span>
          {location && <span className="news-location">{location}</span>}
          {news.pub_date && (
            <span className="news-date">{formatDate(news.pub_date)}</span>
          )}
        </div>
        <h3 className="news-title">{news.title}</h3>
        {news.description && (
          <p className="news-description">{news.description}</p>
        )}
      </div>
      {news.image_url && (
        <img src={news.image_url} alt="" className="news-image" />
      )}
    </a>
  );
};

export default NewsCard;
